<template>
  <div class="main_box">
    <div class="search-box">
      <el-form ref="form" class="flex_form">
        <div>
          <el-input class="store_ipt" v-model="Nickname" :placeholder="$t('enum.userNickname')"></el-input>
        </div>
        <div class="store_btn primary" @click="getData">{{ $t('button.search') }}</div>
      </el-form>
    </div>
    <div class="black-list">
      <el-table :data="List" style="width: 100%;" max-height="500px">
        <el-table-column prop="NickName" :label="$t('enum.userNickname')" width="300">
        </el-table-column>
        <el-table-column  :label="$t('enum.createTime')">
        <template slot-scope="scope">
          <span class="">{{ $store.getters.separatedTime(scope.row.CreateTime, 'cut')[0] }}<br />{{ $store.getters.separatedTime(scope.row.CreateTime, 'cut')[1] }}</span>
        </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('enum.operate')" width="120" class-name="all_operate">
          <template slot-scope="scope">
            <div class="" @click="blackUserDialog(scope.row)">
              <span class="hover underline">{{ $t('button.unblock') }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <list-pagination v-show="Count > 0" ref="Pagination" :total="Count" @getData="getData" />
    <!-- #region 黑名单-拉黑用户 -->
    <el-dialog :title="`${$t('button.unblock')}  ${blackItem.NickName||''}?`" :visible.sync="dialogBlackVisible" @close="dialogBlackVisible = false; blackItem = {}">
      <div style="padding: 20px">{{ $t('enum.unblockTips') }}</div>
      <div slot="footer">
        <el-button @click="dialogBlackVisible = false; blackItem = {}">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="blackUser(blackItem)">{{ $t('button.unblock') }}</el-button>
      </div>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>

import ListPagination from '@/components/listpagination'
export default {
  name: '',
  components: { ListPagination },
  data() {
    return {
      UserInfo: {},
      Nickname: '',
      List: [],
      Count: 0,
      PageIndex: 1,
      PageSize: 999,
      blackItem: {},//拉黑用户信息
      dialogBlackVisible: false,//拉黑用户
    }
  },
  computed: {
  },
  created() {
    this.UserInfo = this.$store.state.UserInfo;
  },
  mounted() {
    this.getData();
  },
  destroyed() {
  },
  methods: {
    getData(PageIndex, PageSize) {
      var that = this;
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&nickName=${that.Nickname}`;

      that.$get('GetBlackList', params).then((res) => {
        if (res.result) {
          var _data = res.data
          that.List = _data;
          that.Count = res.count;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    blackUserDialog(obj) {
      console.log("blackUserDialog", obj);
      //用户拉黑
      let that = this;
      // that.blackItem = obj;
      // that.dialogBlackVisible = true;
      that.blackUser(obj)
    },
    blackUser(obj) {
      let that = this;
      that.$post('OperateBlack', { TargetId: obj.BlackMemberId, Type: 2, mbname: 'web' }) // 移除黑名单
        .then((res) => {
          if (res.result) {
            that.$message({
              showClose: true,
              message: res.msg || 'Successful',
              type: "success",
            });
            that.dialogBlackVisible = false;
            that.getData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
}

.flex_form {
  display: flex;
  margin: 20px 0;
}

.flex_form>div {
  margin-right: 34px;
}

.flex_form .el-input {
  margin: 0 0 0 7px;
}

.store_ipt {
  width: 150px;
}

.store_btn {
  padding: 0 20px;
  height: 36px;
  line-height: 34px;
  color: #333;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  cursor: pointer;
  margin-right: 8px;
}

.primary {
  background-color: #5f6dae;
  border-color: #5f6dae;
  color: #fff;
}

.all_operate div {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/blacklist/index.vue